import request from '@/utils/request'

// 投资事件一览
export function getInvestmentEvent(data) {
  return request({
    url: '/clue/getInvestmentEvent',
    method: 'post',
    data
  })
}

// 根据id查找投资事件
export function getInvestmentEventById(data) {
  return request({
    url: '/clue/getInvestmentEvent',
    method: 'get',
    params: data
  })
}

//编辑线索
export function updateInvestment(data) {
  return request({
    url: '/clue/updateInvestmentEvent',
    method: 'post',
    data
  })
}

//线索附件上传
export function addAccessory(data) {
  return request({
    url: '/clue/addAccessory',
    method: 'post',
    data
  })
}

//线索附件下载(批量)
export function fileDownload(data) {
  return request({
    url: '/clue/fileDownload',
    method: 'get',
    params: data
  })
}

//线索附件下载(单个)
export function fileDownloadSingle(data) {
  return request({
    url: '/clue/fileDownloadSingle',
    method: 'get',
    params: data
  })
}

//线索附件删除
export function deleteAccessory(data) {
  return request({
    url: '/clue/deleteAccessory',
    method: 'get',
    params: data
  })
}

// 批量新增线索
export function saveClue(data) {
  return request({
    url: '/clue/saveClueList',
    method: 'post',
    data
  })
}

// 批量单个新增线索
export function saveClueOne(data) {
  return request({
    url: '/clue/saveClue',
    method: 'post',
    data
  })
}

// 根据条件查询线索列表(带分页)
export function getCluePage(data) {
  return request({
    url: '/clue/getCluePage',
    method: 'post',
    data
  })
}

// 后台文件公共上传
export function uploadAdmin(data) {
  return request({
    url: '/upload/uploadAdmin',
    method: 'post',
    data
  })
}

// h5附件上传
export function uploadAdminH5(data) {
  return request({
    url: '/upload/uploadAdminH5',
    method: 'post',
    data
  })
}

// 线索统计
export function getClueNumber(data) {
  return request({
    url: '/clue/getClueNumber',
    method: 'get',
    params: data
  })
}

// 获取商务经理和其他经理
export function getUser(data) {
  return request({
    url: '/clue/getUser',
    method: 'get',
    params: data
  })
}

// 编辑线索 
export function updateClue(data) {
  return request({
    url: '/clue/updateClue',
    method: 'post',
    data
  })
}

// 进度时间 
export function getClueScheduleTime(data) {
  return request({
    url: '/clue/getClueScheduleTime',
    method: 'get',
    params: data
  })
}

// 关键人一览(带分页) 
export function getKeyPersons(data) {
  return request({
    url: '/clue/getKeyPersons',
    method: 'post',
    data
  })
}

// 新增关键人 
export function saveKeyPerson(data) {
  return request({
    url: '/clue/saveKeyPerson',
    method: 'post',
    data
  })
}

// 关联方一览(带分页)
export function getLinksParty(data) {
  return request({
    url: '/clue/getLinksParty',
    method: 'post',
    data
  })
}

// 企业对接人一览(带分页)
export function getDocking(data) {
  return request({
    url: '/clue/getDocking',
    method: 'post',
    data
  })
}

// 新增关联方
export function saveLinksParty(data) {
  return request({
    url: '/clue/saveLinksParty',
    method: 'post',
    data
  })
}

// 删除关联方
export function deleteLinksParty(data) {
  return request({
    url: '/clue/deleteLinksParty',
    method: 'GET',
    params: data
  })
}

// 编辑关联方
export function updateLinksParty(data) {
  return request({
    url: '/clue/updateLinksParty',
    method: 'post',
    data
  })
}

// 新增企业对接人
export function saveDocking(data) {
  return request({
    url: '/clue/saveDocking',
    method: 'post',
    data
  })
}

// 编辑企业对接人
export function updateDocking(data) {
  return request({
    url: '/clue/updateDocking',
    method: 'post',
    data
  })
}

// 删除企业对接人
export function deleteDocking(data) {
  return request({
    url: '/clue/deleteDocking',
    method: 'get',
    params: data
  })
}

// 关联资讯一览(带分页)
export function getConsulting(data) {
  return request({
    url: '/clue/getConsulting',
    method: 'post',
    data
  })
}

// 根据id查询签约
export function selectContract(data) {
  return request({
    url: '/clue/selectContract',
    method: 'get',
    params: data
  })
}

// 新增/修改签约
export function saveContract(data) {
  return request({
    url: '/clue/saveContract',
    method: 'post',
    data
  })
}

// 编辑关键人、教育经验、工作经验
export function updateKeyPerson(data) {
  return request({
    url: '/clue/updateKeyPerson',
    method: 'post',
    data
  })
}

// 删除关键人、教育经验、工作经验
export function deleteKeyPerson(data) {
  return request({
    url: '/clue/deleteKeyPerson',
    method: 'get',
    params: data
  })
}

// 发送通知
export function sendNotification(data) {
  return request({
    url: '/clue/sendNotification',
    method: 'post',
    data
  })
}

// 附件上传后修改线索 (h5页面发送附件)
export function updateClueAccessory(data) {
  return request({
    url: '/clue/updateClueAccessory',
    method: 'post',
    data
  })
}
